
seedWebApp.value('$', $);

seedWebServices.service('MessageService', ['$', '$rootScope', '$http', '$cacheFactory', function ($, $rootScope, $http, $cacheFactory) {


    var messageCache = $cacheFactory('MessageService'),
        serviceUrl = '../Api/MessageApi/';

    this.resetCache = function () {
        messageCache.removeAll();
    };

    var proxy;
    var connection;
    var newMsgs = 0;
    var channels = [];
    var directChannels = [];

    var directChannel = {
        ChannelID: '3',
        ChannelName: 'Conversas',
        ChannelType: 'direct',
        Unread: 0,
        Description: 'Conversas diretas',
        Users: [],
        selUser: null,
        Messages: []
    };

    var selChannel = null;
    var userID = null;

    this.connect = function (aUserID) {

        userID = aUserID;
        connection = $.hubConnection();
        proxy = connection.createHubProxy('HubMessages');
        var self = this;

        proxy.on('messageAdded', function (fromUser, toUser, message) {
            newMsgs++;
            self.receiveMessage(fromUser, toUser, message, 'delivered');

            $rootScope.$broadcast('messageAdded', fromUser, toUser, message.text, message.sendDate);
        });

        connection.start()
            .done(function () {
                $rootScope.$broadcast('Messages.Connected');
                self.resendQueueMessages();
            })
            .fail(function (error) {
                $rootScope.$broadcast('Messages.ConnectionFail', error);
            }
            );

        connection.disconnected(function () {
            $rootScope.$broadcast('Messages.Disconnected');
        });

        connection.connectionSlow(function () {
            $rootScope.$broadcast('Messages.ConnectionSlow');
        });

        connection.stateChanged(function (change) {
            $rootScope.$broadcast('Messages.StateChanged', change);
        });

        connection.error(function (error) {
            $rootScope.$broadcast('Messages.Error', error);
        });
    };

    this.resendQueueMessages = function () {
        if (!selChannel) {
            return;
        }
        var num = 0;
        for (var i = 0; i < selChannel.Messages.length; i++) {
            var msg = selChannel.Messages[i];
            if (msg.status === 'queued') {
                num++;
                proxy.invoke('SendMessage', msg.fromUser, msg.toUser, msg);
            }
        }
    };

    this.isConnecting = function () {
        if (!connection) {
            return false;
        }
        return connection.state === 0;
    };

    this.isConnected = function () {
        if (!connection) {
            return false;
        }
        return connection.state === 1;
    };

    this.connectionState = function () {
        if (!connection) {
            return 'Disabled';
        }
        return connection.state;
    };

    this.reconnect = function (userID) {
        this.connect(userID);
        if (selChannel) {
            this.loadLastMessages(selChannel);
        }
    };

    this.sendMessage = function (fromUser, toUser, message) {
        var sentID = fromUser + '.' + moment().utc().toISOString();
        var msgDate = moment().utc().toISOString();
        var msg = {
            SentID: sentID,
            text: message,
            MsgText: message,
            MsgTime: msgDate,
            state: 'queued'
        };

        this.addMessage(fromUser, toUser, msg, 'queued');
        if (this.isConnected()) {
            proxy.invoke('SendMessage', fromUser, toUser, msg);
        }
    };

    this.receiveMessage = function (fromUser, toUser, msg, msgStatus) {

        if (!selChannel) {
            return;
        }

        if (msg.SentID) {
            for (var i = 0; i < selChannel.Messages.length; i++) {
                var queueMsg = selChannel.Messages[i];
                if (queueMsg.SentID === msg.SentID) {
                    queueMsg.status = 'sent';
                    return;
                }
            }
        }

        this.addMessage(fromUser, toUser, msg, msgStatus);
    };

    this.addMessage = function (fromUser, toUser, msg, msgStatus) {

        var recMsg = { from: fromUser, toUser: toUser };
        if (fromUser === userID) {
            recMsg.Sent = true;
        }

        recMsg.SentID = msg.SentID;
        recMsg.status = msgStatus;

        recMsg.imageName = this.getAvatar(fromUser);

        recMsg.MsgTitle = msg.MsgTitle;
        recMsg.MsgText = msg.MsgText; //message;
        recMsg.MsgColor = msg.MsgColor;
        recMsg.MsgLink = msg.MsgLink;
        recMsg.UserFrom = fromUser;
        recMsg.MsgTime = msg.MsgTime;

        this.formatMessage(recMsg);

        var recChannel = null;
        if (selChannel.ChannelID === toUser) {
            recChannel = selChannel;
        }
        else {
            recChannel = this.findChannel(toUser);
            if (recChannel) {
                recChannel.Unread++;
            }
        }

        //Verificar se e o canal certo...
        if (recChannel) {
            recChannel.Messages.push(recMsg);
        }
    };

    this.getNewMsgs = function () {
        return newMsgs;
    };

    this.clearNewMsgs = function () {
        newMsgs = 0;
        $rootScope.$broadcast('messagesCleared');
    };

    this.addChannelUsers = function (channel, users) {
        var data = {
            ActionTag: 'ADD_CHANNEL_USERS',
            ChannelID: channel.ChannelID,
            Users: users
        };
        return $http.put('../Api/MessageApi/', data);
    };

    this.loadChannels = function () {
        var loading = true;
        var self = this;
        var loadError = null;
        $http.get('../Api/MessageApi/', {
            params: { actionTag: 'GetChannels', id: userID },
            cache: true
        }).then(
            function (result) {
                loading = false;
                channels = result.data.Channels;
                directChannels = result.data.DirectChannels;
                if (channels.length > 0) {
                    selChannel = channels[0];
                    self.loadLastMessages(selChannel);
                }
                $rootScope.$broadcast('Messages.ChannelsLoaded', channels, directChannels);
            },
            function (error) {
                loading = false;
                loadError = error.data;
                $rootScope.$broadcast('Messages.Error', loadError);
            }
            );
    };

    this.getChannels = function () {
        return channels;
    };

    this.postChannel = function (channel) {
        if (channel.ChannelType === 'direct') {
            directChannels.push(channel);
        }
        else {
            channels.push(channel);
        }
        channel.ActionTag = 'CREATE_CHANNEL';
        return $http.put('../Api/MessageApi/', channel);
    };

    //JRM: Procurar canal ou USUARIO (conversas)
    this.findChannel = function (id) {
        for (var i = 0; i < channels.length; i++) {
            if (channels[i].ChannelID === id) {
                return channels[i];
            }
        }
        return null;
    };

    this.setChannel = function (channel) {
        selChannel = channel;
        if (!selChannel.loaded) {
            this.loadLastMessages(selChannel);
        }
    };

    this.getChannel = function () {
        return selChannel;
    };

    this.setUser = function (user) {
        directChannel.selUser = user;
        directChannel.Messages = user.Messages;
    };

    this.isUserSelected = function (user) {
        if (!directChannel.selUser) {
            return false;
        }
        if (directChannel.selUser.UserID === user.UserID) {
            return true;
        }
        return false;
    };

    this.getDirectChannel = function () {
        return directChannel;
    };

    this.getAvatar = function (userID) {
        var avatar = '';
        if (userID) {
            avatar = userID.toLowerCase().substr(0, 2);
        }
        else {
            avatar = 'aa';
        }
        return avatar + '.png';
    };

    this.loadUsersNotInChannel = function (channel) {
        channel.loadingUsers = true;
        var self = this;
        $http.get(serviceUrl, {
            params: { actionTag: 'GetUsersNotInChannel', id: channel.ChannelID },
            cache: true
        }).then(
            function (result) {
                channel.loadingUsers = false;
                channel.UsersNotInChannel = result.data;
                self.updateUsersNotInChannel(channel);
            },
            function () {
                channel.loadingUsers = false;
            }
            );
    };

    this.updateUsersNotInChannel = function (channel) {
        for (var i = 0; i < channel.Users.length; i++) {
            var user = channel.Users[i];
            this.removeUserNotInChannel(channel, user.UserID);
        }
    };

    this.removeUserNotInChannel = function (channel, userID) {
        for (var i = 0; i < channel.UsersNotInChannel.length; i++) {
            var user = channel.UsersNotInChannel[i];
            if (user.UserID === userID) {
                channel.UsersNotInChannel.splice(i, 1);
                return;
            }
        }
    };

    this.loadLastMessages = function (channel) {
        return this.loadMessages(channel, 'now');
    };

    this.loadMoreMessages = function (channel) {
        return this.loadMessages(channel, channel.LatestMsgID);
    };

    this.loadMessages = function (channel, latestMsgID) {
        channel.loading = true;
        channel.loaded = false;
        var self = this;
        $http.get(serviceUrl, {
            params: { actionTag: 'GetLastMessages', id: channel.ChannelID, LatestMsgID: latestMsgID },
            cache: true
        }).then(
            function (result) {
                channel.loading = false;
                channel.loaded = true;
                var messages = result.data.Msgs;
                self.formatMessages(messages);
                if (latestMsgID === 'now') {
                    channel.Messages = messages;
                }
                else {
                    Array.prototype.push.apply(channel.Messages, messages);
                }

                channel.PageSize = result.data.PageSize;
                channel.LatestMsgID = result.data.LatestMsgID;
                channel.HasMore = result.data.HasMore;
                $rootScope.$broadcast('Messages.MessagesLoaded', channel, latestMsgID);
            },
            function () {
                channel.loading = false;
            }
            );
    };

    //Troca LineFeed por <br/>
    this.formatMessages = function (messages) {
        for (var i = 0; i < messages.length; i++) {
            this.formatMessage(messages[i]);
        }
    };

    this.formatMessage = function (msg) {
        if (msg.MsgText) {
            msg.MsgText = msg.MsgText.replace(/(?:\r\n|\r|\n)/g, '<br />');
        }
    };

    this.getAction = function (actionTag, id, useCache) {
        var cache = false;
        if (useCache) {
            cache = messageCache;
        }
        return $http.get(serviceUrl, {
            params: { actionTag: actionTag, id: id },
            cache: cache
        });
    };
}]);